import {
  Select,
  SelectContent,
  SelectGroup,
  SelectTrigger,
  SelectItem,
} from '@e2n/ui';
import {
  getWeekdayOccurrenceStringFromTerminWeekdayOccurrence,
  TerminWeekdayOccurrence,
  TerminWiederholungsIntervall,
} from '@/domain/termine/shared/types';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

const validIntervals = Object.values(TerminWiederholungsIntervall);

function isTerminWiederholungsIntervall(
  value: string,
): value is TerminWiederholungsIntervall {
  return validIntervals.some((interval) => interval === value);
}

function renderWeekdayOccurrenceSelect(
  value: TerminWeekdayOccurrence | undefined,
  onChange: (value: TerminWeekdayOccurrence) => void,
  date: string | undefined,
  selectedRepetition: string | undefined,
) {
  const repetition =
    selectedRepetition && isTerminWiederholungsIntervall(selectedRepetition)
      ? selectedRepetition
      : TerminWiederholungsIntervall.WOCHE;

  return (
    <div className="pb-3 h-10">
      <Select value={value ?? undefined} onValueChange={onChange}>
        <SelectTrigger className="border-neutrals-300 w-full">
          <div>
            {value
              ? getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
                  value,
                  date,
                  repetition,
                )
              : ''}
          </div>
        </SelectTrigger>
        <SelectContent className="border-none overflow-visible">
          <SelectGroup className="p-1">
            {Object.values(TerminWeekdayOccurrence).map((enumValue) => (
              <SelectItem className="p-2" key={enumValue} value={enumValue}>
                {getWeekdayOccurrenceStringFromTerminWeekdayOccurrence(
                  enumValue,
                  date,
                  repetition,
                )}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}

export default function WeekdayOccurrence({
  value,
  onChange,
}: {
  value: TerminWeekdayOccurrence | undefined;
  onChange: (value: TerminWeekdayOccurrence) => void;
}) {
  const { form } = useCreateTermineFormContext();
  return (
    <form.Subscribe
      selector={(state) => [
        state.values.datum,
        state.values.wiederholungsIntervall,
      ]}>
      {([date, selectedRepetition]) =>
        renderWeekdayOccurrenceSelect(value, onChange, date, selectedRepetition)
      }
    </form.Subscribe>
  );
}
